import React, { useState } from 'react';

import { Alert, Box, Stack } from '@mui/material';

import AddBusinessSettingForm from '~/components/LeBusinessTraveller/components/businessSettings/AddBusinessSettingForm';
import SocieteSettingForm, {
  SocieteSettingDraft,
} from '~/components/LeBusinessTraveller/components/businessSettings/SocieteSettingForm';

import { BusinessSettingName, BusinessSettingsResponse } from '~/services/BusinessTraveller/BusinessTravellerService';

import { DEFAULT_SOCIETE } from '~/utils/businessTraveller/businessSettings';

// Tab-local state mirrors the server BusinessSettingsResponse shape but each entry's id is optional
// (drafts the user just added via "Add setting" have no id until first save).
type BusinessSettingForms = {
  societe?: SocieteSettingDraft;
};

interface Props {
  businessId?: string;
  initialSettings: BusinessSettingsResponse;
  error: Error | null;
}

export default function BusinessSettingTabContent({ businessId, initialSettings, error }: Props) {
  const [businessSettingForms, setBusinessSettingForms] = useState<BusinessSettingForms>(initialSettings);

  const societeForm = businessSettingForms.societe;
  const existingSettingNames = Object.keys(businessSettingForms) as Array<BusinessSettingName>;
  const isEmpty = existingSettingNames.length === 0;

  const handleAdd = (settingName: BusinessSettingName) => {
    if (settingName === 'societe') {
      setBusinessSettingForms((prev) => ({ ...prev, societe: { value: DEFAULT_SOCIETE } }));
    }
  };

  return (
    <Box>
      <Stack gap={3}>
        {error && <Alert severity="error">Error fetching business settings</Alert>}

        {isEmpty && (
          <Alert severity="info">
            {businessId
              ? 'No override settings for this business. Add a setting to override the global defaults.'
              : 'No default settings configured. Add a setting to set a default.'}
          </Alert>
        )}

        {societeForm && <SocieteSettingForm setting={societeForm} businessId={businessId} />}

        <AddBusinessSettingForm existingSettingNames={existingSettingNames} onAdd={handleAdd} />
      </Stack>
    </Box>
  );
}
